// src/MantisBusiness/Notifications.jsx
import React, { useState, useEffect, useRef } from "react";
import InboxNotification from "./InboxNotification";
import "../../styles/businessBackofficeStyles.scss";
import { BellRing } from "lucide-react";

function Notifications() {
  const [showNotifications, setShowNotifications] = useState(false);
  const notificationRef = useRef(null);

  const toggleNotifications = () => {
    setShowNotifications(!showNotifications);
  };

  // Close notifications when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        notificationRef.current &&
        !notificationRef.current.contains(event.target)
      ) {
        // Check if the click was not on the bell icon
        const bellElement = document.querySelector(".notification-bell");
        if (bellElement && !bellElement.contains(event.target)) {
          setShowNotifications(false);
        }
      }
    };

    if (showNotifications) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showNotifications]);

  return (
    <div>
      <div className="notification-bell" onClick={toggleNotifications}>
        <BellRing />
      </div>
      {showNotifications && (
        <div className="notifications-modal" ref={notificationRef}>
          <InboxNotification />
        </div>
      )}
    </div>
  );
}

export default Notifications;